import { GreyArrow, GreyBubble } from "../../../../../components/mammoth/GreyBubble";
import React from "react";
import styled from "styled-components/macro";

const BubbleWrap3 = styled.div`
  margin: 0 -8px -20px;
`;
const BubbleWrap2 = styled.div`
  margin: 0 auto;
  width: 360px;
`;
const BubbleWrap = styled.div`
  margin: 0 auto 0 0;
  width: 246px;
`;
const SGreyBubble = styled(GreyBubble)<{ $background?: string }>`
  margin: 0 auto 0 0;
  background: ${({ theme, $background }) => $background || `${theme.duo.color.lightGrey}66`};
  z-index: 3;
`;

const SGreyArrow = styled(GreyArrow)<{ $background?: string }>`
  background: ${({ theme, $background }) => $background || theme.duo.color.lightGrey};
`;

type Props = {
  children: React.ReactNode;
  petting?: boolean;
  background?: string;
};

export function QuestBubble({ children, petting, background }: Props) {
  return (
    <BubbleWrap3>
      <BubbleWrap2>
        <BubbleWrap>
          <SGreyBubble hidden={petting} $background={background}>
            {children}
            <SGreyArrow $background={background} />
          </SGreyBubble>
        </BubbleWrap>
      </BubbleWrap2>
    </BubbleWrap3>
  );
}
